import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, unref as _unref, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e414c38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "params-block" }
const _hoisted_2 = {
  key: 0,
  class: "params-block__box"
}
const _hoisted_3 = { class: "params-block__name medium" }
const _hoisted_4 = {
  key: 0,
  class: "params-block__name-distance"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "none-Mobile" }, ",", -1))
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "items-in-line"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 4,
  class: "items-in-line"
}
const _hoisted_14 = { key: 3 }

import { ParamType } from '@/store/modules/searchRealEstate';
import { OptionType } from '@/api/common/types';
import { SearchParamsDataType } from '@/types';
import { computed } from 'vue';
import { vMaska } from 'maska';

const heightInput = '34';


export default /*#__PURE__*/_defineComponent({
  __name: 'ParamsBlock',
  props: /*#__PURE__*/_mergeModels({
    activeParams: {},
    visibleParameters: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['changeVisibleCategory', 'changeDistance'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
// eslint-disable-next-line no-undef
const paramsValues = _useModel<SearchParamsDataType>(__props, "modelValue");
const isMinMaxType = (options: OptionType) => {
  const type = options['search2-visual'];

  if (type) {
    return type === '3' || type === '6' || type === '7' || type === '8';
  }

  return false;
};

const isOnlyMax = (options: OptionType) => {
  const type = options['search2-visual'];

  if (type) {
    return type === '2' || type === '9' || type === '10' || type === '11';
  }

  return false;
};
const modelValue = computed(() => {});
const prepareOptions = (options: OptionType) => {
  return Object.entries(options.list.items).map(item => {
    return {
      id: item[0],
      name: item[1],
    };
  });
};

return (_ctx: any,_cache: any) => {
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_date_picker = _resolveComponent("base-date-picker")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_checkbox_input = _resolveComponent("base-checkbox-input")!
  const _component_base_select_input = _resolveComponent("base-select-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeParams, (category) => {
      return (_openBlock(), _createElementBlock("div", null, [
        (category.options.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, _toDisplayString(category.categoryName), 1),
                (category.distance)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _hoisted_5,
                      _createTextVNode(" расстояние в "),
                      _createElementVNode("button", {
                        class: _normalizeClass([{ 'main-color medium': category.distance === 'km' }, "underline"]),
                        disabled: category.distance === 'km',
                        onClick: ($event: any) => (_ctx.$emit('changeDistance', { id: category.paramId, value: 'km' }))
                      }, " километрах ", 10, _hoisted_6),
                      _createTextVNode(" / "),
                      _createElementVNode("button", {
                        class: _normalizeClass([{ 'main-color medium': category.distance === 'm' }, "underline"]),
                        disabled: category.distance === 'm',
                        onClick: ($event: any) => (_ctx.$emit('changeDistance', { id: category.paramId, value: 'm' }))
                      }, " метрах ", 10, _hoisted_7)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_base_divider, {
                  class: "only-mobile mt--10 mb--10",
                  color: "#009D3E"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass([{
            visible:
              _ctx.visibleParameters.includes(category.paramId) || _ctx.activeParams?.length <= 1,
          }, "params-block__inputs"])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.options, (input) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: input.id
                  }, [
                    (paramsValues.value && paramsValues.value[String(input.id)])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (!isMinMaxType(input.options))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                (isOnlyMax(input.options))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                      (
                      input.type === 12 ||
                      input.type === 13 ||
                      input.type === 19 ||
                      input.type === 20
                    )
                                        ? (_openBlock(), _createBlock(_component_base_date_picker, {
                                            key: 0,
                                            modelValue: paramsValues.value[String(input.id)].max,
                                            "onUpdate:modelValue": ($event: any) => ((paramsValues.value[String(input.id)].max) = $event),
                                            flow: ['year', 'month', 'calendar'],
                                            height: heightInput,
                                            label: input.title,
                                            "month-picker": input.type === 20,
                                            "year-picker": input.type === 19,
                                            "with-bg": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "month-picker", "year-picker"]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            _createVNode(_component_base_input, {
                                              modelValue: paramsValues.value[String(input.id)].max,
                                              "onUpdate:modelValue": ($event: any) => ((paramsValues.value[String(input.id)].max) = $event),
                                              height: heightInput,
                                              isPercent: input.type === 6,
                                              label: input.title,
                                              max: 
                        input.type === 6
                          ? 100
                          : input.options.max
                            ? +input.options.max
                            : undefined
                      ,
                                              min: input.options.min ? +input.options.min : undefined,
                                              styles: { border: '1px solid #94857d' },
                                              type: 
                        input.type === 2 || input.type === 5 || input.type === 6
                          ? 'number'
                          : 'text'
                      ,
                                              hideArrows: "",
                                              "with-bg": ""
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "isPercent", "label", "max", "min", "type"])
                                          ]))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                      (
                      input.type === 12 ||
                      input.type === 13 ||
                      input.type === 19 ||
                      input.type === 20
                    )
                                        ? (_openBlock(), _createBlock(_component_base_date_picker, {
                                            key: 0,
                                            modelValue: paramsValues.value[String(input.id)].value,
                                            "onUpdate:modelValue": ($event: any) => ((paramsValues.value[String(input.id)].value) = $event),
                                            flow: ['year', 'month', 'calendar'],
                                            height: heightInput,
                                            label: input.title,
                                            "month-picker": input.type === 20,
                                            "year-picker": input.type === 19,
                                            "with-bg": ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "month-picker", "year-picker"]))
                                        : (input.type === 3)
                                          ? (_openBlock(), _createBlock(_component_base_checkbox_input, {
                                              key: 1,
                                              modelValue: paramsValues.value[String(input.id)].value,
                                              "onUpdate:modelValue": ($event: any) => ((paramsValues.value[String(input.id)].value) = $event),
                                              height: heightInput,
                                              label: input.title
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                          : (input.type === 4 || input.type === 14)
                                            ? (_openBlock(), _createBlock(_component_base_select_input, {
                                                key: 2,
                                                height: heightInput,
                                                isMulti: input.type === 14,
                                                label: input.title,
                                                modelValue: paramsValues.value[String(input.id)].value,
                                                options: prepareOptions(input.options),
                                                searchCount: 
                      input.options['search2-visual'] === '15' ||
                      input.options['search2-visual'] === '13'
                        ? 5
                        : 7
                    ,
                                                arrow: "expand_more",
                                                clearable: "",
                                                "with-bg": "",
                                                "onUpdate:modelValue": ($event: any) => (paramsValues.value[String(input.id)].value = $event)
                                              }, null, 8, ["isMulti", "label", "modelValue", "options", "searchCount", "onUpdate:modelValue"]))
                                            : (input.type === 23)
                                              ? _withDirectives((_openBlock(), _createBlock(_component_base_input, {
                                                  key: 3,
                                                  modelValue: paramsValues.value[input.id].value,
                                                  "onUpdate:modelValue": ($event: any) => ((paramsValues.value[input.id].value) = $event),
                                                  height: heightInput,
                                                  label: input.title,
                                                  "data-maska": "##:##:######:##",
                                                  hideArrows: "",
                                                  placeholder: "47:14:120301:814",
                                                  "with-bg": ""
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])), [
                                                  [_unref(vMaska)]
                                                ])
                                              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                  _createVNode(_component_base_input, {
                                                    modelValue: paramsValues.value[String(input.id)].value,
                                                    "onUpdate:modelValue": ($event: any) => ((paramsValues.value[String(input.id)].value) = $event),
                                                    height: heightInput,
                                                    isPercent: input.type === 6,
                                                    label: input.title,
                                                    max: 
                        input.type === 6
                          ? 100
                          : input.options.max
                            ? +input.options.max
                            : undefined
                      ,
                                                    min: input.options.min ? +input.options.min : undefined,
                                                    styles: { border: '1px solid #94857d' },
                                                    type: 
                        input.type === 2 || input.type === 5 || input.type === 6
                          ? 'number'
                          : 'text'
                      ,
                                                    hideArrows: "",
                                                    "with-bg": ""
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "isPercent", "label", "max", "min", "type"])
                                                ]))
                                    ]))
                              ]))
                            : (paramsValues.value[String(input.id)])
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass([{ withText: input.type === 27 }, "params-block__inputs-group"])
                                }, [
                                  (
                    input.type === 12 ||
                    input.type === 13 ||
                    input.type === 19 ||
                    input.type === 20
                  )
                                    ? (_openBlock(), _createBlock(_component_base_date_picker, {
                                        key: 0,
                                        modelValue: paramsValues.value[String(input.id)].min,
                                        "onUpdate:modelValue": ($event: any) => ((paramsValues.value[String(input.id)].min) = $event),
                                        flow: ['year', 'month', 'calendar'],
                                        height: heightInput,
                                        label: input.title,
                                        "month-picker": input.type === 20,
                                        "year-picker": input.type === 19,
                                        backgroundColor: "#F9F8FD",
                                        "with-bg": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "month-picker", "year-picker"]))
                                    : (_openBlock(), _createBlock(_component_base_input, {
                                        key: 1,
                                        modelValue: paramsValues.value[String(input.id)].min,
                                        "onUpdate:modelValue": ($event: any) => ((paramsValues.value[String(input.id)].min) = $event),
                                        height: String(+heightInput - 2),
                                        label: input.title + ' от',
                                        styles: {
                    backgroundColor: '#F9F8FD',
                    border: 'none',
                    borderRadius: '10px 0 0 10px',
                  },
                                        hideArrows: "",
                                        type: "number",
                                        "with-bg": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "height", "label"])),
                                  _createVNode(_component_base_divider, {
                                    class: "params-block__inputs-group-divider",
                                    inset: "80%",
                                    vertical: ""
                                  }),
                                  (
                    input.type === 12 ||
                    input.type === 13 ||
                    input.type === 19 ||
                    input.type === 20
                  )
                                    ? (_openBlock(), _createBlock(_component_base_date_picker, {
                                        key: 2,
                                        modelValue: paramsValues.value[String(input.id)].max,
                                        "onUpdate:modelValue": ($event: any) => ((paramsValues.value[String(input.id)].max) = $event),
                                        flow: ['year', 'month', 'calendar'],
                                        height: heightInput,
                                        label: input.title,
                                        "month-picker": input.type === 20,
                                        "year-picker": input.type === 19,
                                        backgroundColor: "#F9F8FD",
                                        "with-bg": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "month-picker", "year-picker"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_base_input, {
                                    modelValue: paramsValues.value[String(input.id)].max,
                                    "onUpdate:modelValue": ($event: any) => ((paramsValues.value[String(input.id)].max) = $event),
                                    height: String(+heightInput - 2),
                                    label: input.title + ' до',
                                    styles: {
                    backgroundColor: '#F9F8FD',
                    border: 'none',
                    borderRadius: '0 10px 10px 0',
                  },
                                    hideArrows: "",
                                    type: "number",
                                    "with-bg": ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "height", "label"]),
                                  (input.type === 27)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, "км"))
                                    : _createCommentVNode("", true)
                                ], 2))
                              : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 256))
  ]))
}
}

})